export default __webpack_public_path__ + "static/media/Grau.73a17916.jpg";